import API from "@common/API"

const AuditService = {
  getAuditChangesForProject(projectId: string): Promise<unknown> {
    return API.get(`/audit/projects/${projectId}?diff=true`)
  },
}

export default AuditService
